import {
  ON_LOGGEDIN
} from "../actions";

const initialState = {
  isLoggedin: localStorage.getItem('isLoggedIn') === 'true',
};

const loginReducer = (state = initialState, action) => {
  switch (action.type) {

    case ON_LOGGEDIN: {
      return {
        ...state,
        isLoggedin: action.payload,
      };
    }

    default:
      return state;
  }
};

export default loginReducer;
